export const CALLISTO_STATIC_URL = "https://www.projectcallisto.org";
export const SERVER_URL = "";

// BADGE_SALT will never change based on environments.

export const BADGE_SALT = "0ddMh4J8gWtnC4Gt";
